import { WorkInjuryEmployerLiabilityBundle } from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import { CoverageLimit, CoverageLimitType } from "@wingspanhq/wingspan-api-sdk";

export const selectorWorkersCompLimitMapper = (
  workersCompLimitMinimum?: WorkInjuryEmployerLiabilityBundle
) => {
  const limits: CoverageLimit[] = [];
  if (!workersCompLimitMinimum) {
    console.error("No workers comp limit minimum provided/selected");
    return limits;
  }

  // Set limits by bundle
  let workersCompPerAcc = 0;
  let workersCompTotalForDisease = 0;
  let workersCompPerEmployeeDisease = 0;
  if (
    workersCompLimitMinimum ===
    WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred
  ) {
    workersCompPerAcc = 1000000;
    workersCompTotalForDisease = 500000;
    workersCompPerEmployeeDisease = 1000000;
  } else if (
    workersCompLimitMinimum ===
    WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred
  ) {
    workersCompPerAcc = 500000;
    workersCompTotalForDisease = 500000;
    workersCompPerEmployeeDisease = 500000;
  } else if (
    workersCompLimitMinimum ===
    WorkInjuryEmployerLiabilityBundle.OneMillionBundle
  ) {
    workersCompPerAcc = 1000000;
    workersCompTotalForDisease = 1000000;
    workersCompPerEmployeeDisease = 1000000;
  }

  limits.push(
    {
      limitType: CoverageLimitType.EMPLOYERS_LIABILITY_EACH_ACCIDENT,
      amount: workersCompPerAcc,
      currency: "USD"
    },
    {
      limitType: CoverageLimitType.EMPLOYERS_LIABILITY_DISEASE_POLICY_LIMIT,
      amount: workersCompTotalForDisease,
      currency: "USD"
    },
    {
      limitType: CoverageLimitType.EMPLOYERS_LIABILITY_DISEASE_EACH_EMPLOYEE,
      amount: workersCompPerEmployeeDisease,
      currency: "USD"
    }
  );

  return limits;
};
